"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cube_model_1 = require("./cube.model");
function cube(ctx, node) {
  new cube_model_1.Cube(node.rect, node.z, node.zRotate, node.fillStyle, node.strokeStyle).render(ctx);
}
exports.cube = cube;